export default __webpack_public_path__ + "static/exCo-2cdbac32140da23733102349cef1cacd.svg";